var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.15,6.088L8.841,9.186C8.116,8.454 7.111,8 6,8C3.792,8 2,9.792 2,12C2,14.208 3.792,16 6,16C7.111,16 8.117,15.546 8.842,14.814L14.151,17.908C14.053,18.255 14,18.621 14,19C14,21.208 15.792,23 18,23C20.208,23 22,21.208 22,19C22,16.792 20.208,15 18,15C16.891,15 15.887,15.452 15.162,16.182L9.85,13.087C9.948,12.741 10,12.377 10,12C10,11.623 9.948,11.258 9.85,10.912L15.159,7.814C15.884,8.546 16.889,9 18,9C20.208,9 22,7.208 22,5C22,2.792 20.208,1 18,1C15.792,1 14,2.792 14,5C14,5.377 14.052,5.742 14.15,6.088ZM16.216,18.095C16.078,18.367 16,18.674 16,19C16,20.104 16.896,21 18,21C19.104,21 20,20.104 20,19C20,17.896 19.104,17 18,17C17.307,17 16.696,17.353 16.337,17.89C16.321,17.925 16.304,17.959 16.284,17.993C16.263,18.029 16.241,18.063 16.216,18.095ZM7.702,10.949C7.349,10.38 6.719,10 6,10C4.896,10 4,10.896 4,12C4,13.104 4.896,14 6,14C6.719,14 7.349,13.62 7.702,13.05C7.709,13.036 7.718,13.021 7.726,13.007C7.735,12.991 7.744,12.977 7.753,12.962C7.911,12.676 8,12.349 8,12C8,11.651 7.911,11.324 7.753,11.038C7.744,11.024 7.735,11.009 7.726,10.994C7.718,10.979 7.71,10.964 7.702,10.949ZM16.298,6.051C16.651,6.62 17.281,7 18,7C19.104,7 20,6.104 20,5C20,3.896 19.104,3 18,3C16.896,3 16,3.896 16,5C16,5.349 16.089,5.676 16.247,5.962C16.256,5.976 16.265,5.991 16.274,6.006C16.282,6.021 16.29,6.036 16.298,6.051Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.ab764b8f.svg";
export { ForwardRef as ReactComponent };